export default __webpack_public_path__ + "static/media/new-check-cuad.556bd0a9.svg";